import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, toRef } from "vue";
import QExpandableDataTable from "../../../components/datatables/QExpandableDataTable.vue";
import { RecruitCentricMetrics } from "../api";
import BlueBox from "./BlueBox.vue";
import { useColumnAveragePercent } from "../composables/useColumnAverage";
import AgentNameCol from "./AgentNameCol.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AoRecruitsDataTable',
  props: {
  items: { type: Array as PropType<RecruitCentricMetrics[]>, default: () => [] },
},
  setup(__props) {

const props = __props



const headers = [
	{
		text: "Agent Name",
		value: "AgentName",
	},
	{
		text: "RTW to Writer",
		value: "WritersPerAgent",
	},
	{
		text: "RTW to Active Writer",
		value: "ActiveWritersPerAgent",
	},
	{
		text: "RTW to SNA",
		value: "ActiveWritersPerAgent",
	},
	{
		text: "Average",
		value: "Average",
	},
];

// const top10Apv = useColumnAveragePercent(toRef(props, 'items'), 'WritersPerAgent')
// const top10Apps = useColumnAveragePercent(toRef(props, 'items'), 'ActiveWritersPerAgent')
// const top10Writer = useColumnAveragePercent(toRef(props, 'items'), 'SNAsPerAgent')

return { __sfc: true,props, headers, QExpandableDataTable, AgentNameCol }
}

})